import { useState } from 'react';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';
import { ImageUploader } from '@/components/ImageUploader';

interface OnboardingStep1Props {
  familyName: string;
  familyPhoto?: string;
  onUpdate: (name: string) => void;
  onPhotoUpdate: (photo: string | undefined) => void;
}

export const OnboardingStep1 = ({ familyName, familyPhoto, onUpdate, onPhotoUpdate }: OnboardingStep1Props) => {
  const [localName, setLocalName] = useState(familyName);

  const handleChange = (value: string) => {
    setLocalName(value);
    onUpdate(value);
  };

  return (
    <div className="onboarding-step px-6">
      {/* Header décoratif */}
      <div className="text-center space-y-4 mb-8 pt-8">
        <div className="text-6xl mb-4">👨‍👩‍👧‍👦</div>
        <h2 className="text-3xl font-bold text-foreground">Créons votre famille</h2>
        <p className="text-lg text-muted-foreground">
          Commençons par choisir le nom de votre famille
        </p>
      </div>

      {/* Formulaire */}
      <div className="max-w-sm mx-auto w-full">
        <div className="space-y-3">
          <Label htmlFor="familyName" className="text-base font-medium text-foreground">
            Nom de famille
          </Label>
          <div className="relative">
            <div className="flex items-center h-14 border border-input rounded-md bg-background overflow-hidden">
              <span className="pl-3 pr-1 text-lg text-muted-foreground">Famille</span>
              <input
                id="familyName"
                value={localName}
                onChange={(e) => handleChange(e.target.value)}
                placeholder="Dupont"
                className="flex-1 h-full px-2 text-lg bg-transparent border-0 outline-none ring-0 focus:ring-0"
              />
            </div>
          </div>
        </div>

        {/* Photo de famille */}
        <div className="space-y-3 mt-8">
          <Label className="text-base font-medium text-foreground">
            Photo de famille <span className="text-sm text-muted-foreground">(facultatif)</span>
          </Label>
          <ImageUploader
            currentImageUrl={familyPhoto}
            onImageUploaded={onPhotoUpdate}
            bucketPath="family-photos"
            size="banner"
          />
        </div>
      </div>
    </div>
  );
};